import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CustomCursorComponent as CustomCursorComponentCore } from '@df/ui/display/custom-cursor/custom-cursor.component';

@Component({
    selector: 'custom-cursor, [customCursor]',
    template: `
        <ng-container *ngTemplateOutlet="customCursorContent" />
        @if (!isDisabled()) {
        <div class="custom-cursor" [@cursorAnimation]="cursorState" #customCursor [style.background-color]="color()">
            <ng-container *ngTemplateOutlet="customCursorIcon" />
        </div>
        }
    `,
    styleUrl: './custom-cursor.scss',
    standalone: true,
    imports: [CommonModule],
    animations: [
        trigger('cursorAnimation', [
            state(
                'hide',
                style({
                    opacity: 0,
                    visibility: 'hidden'
                })
            ),
            state(
                'show',
                style({
                    opacity: 1,
                    visibility: 'visible'
                })
            ),
            transition('* => show', [style({ opacity: 0, visibility: 'visible' }), animate('250ms', style({ opacity: 1 }))]),
            transition('show => *', [style({ opacity: 1, visibility: 'visible' }), animate('250ms', style({ opacity: 0 }))])
        ])
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomCursorComponent extends CustomCursorComponentCore {
    color = input<string | null>(null);
}
